import React from "react";
import "./ProductPortfolio.css";
// import FaArrowRight from "../assets/arr.png";

import pink from "../assets/paintpink4.png";
import blue from "../assets/paintblue4.png";
import yellow from "../assets/paintYellow4.png";
import navy from "../assets/paintNavy4.png";
import red from "../assets/paintRed4.png";
import green from "../assets/paintGloss4.png";
import cyan from "../assets/paintCyan4.png";
import { useNavigate } from "react-router-dom";
const ProductPortfolio = () => {
  const navigate = useNavigate();

  const openProduct = (productId) => {
    navigate(`/products/${productId}`);
  };

  const handleCardKeyDown = (event, productId) => {
    if (event.key === "Enter" || event.key === " ") {
      event.preventDefault();
      openProduct(productId);
    }
  };

  const products = [
    // ROW 1 (2 cols)
    {
      id: 5,
      name: "Aquatic Matt Emulsion",
      description:
        "Special water-based paint giving excellent coverage and a beautiful finish. Ideal for modern design applications requiring a soft, elegant wall texture.",
      img: pink,
      comingSoon: true,
    },
    {
      id: 1,
      name: "Plastic Emulsion",
      description:
        "Our flagship interior paint solution offers excellent coverage, washability, and long-term durability for everyday environments under Pakistani climate conditions.",
      img: blue,
    },
    // ROW 2 (3 cols)
    {
      id: 6,
      name: "Weather Guard",
      description:
        "Premium exterior paint designed to withstand Pakistan’s harsh conditions. Anti-fungal and UV-resistant for exterior walls and surfaces requiring maximum protection.",
      img: navy,
      comingSoon: true,
    },
    {
      id: 2,
      name: "High Class Emulsion",
      description:
        "Our luxury interior paint line ensures top-class quality, easy maintenance, and a flawless finish — perfect for premium and residential projects requiring elegant appeal.",
      img: red,
      comingSoon: true,
    },
    {
      id: 3,
      name: "Wall Putty",
      description:
        "Essential for a strong, smooth, professional wall finish. Offers excellent adhesion for paint application, ensuring longer-lasting results.",
      img: yellow,
    },
    // ROW 3 (2 cols)
    {
      id: 4,
      name: "Gloss Enamel",
      description:
        "High-quality enamel paint providing gloss, durable finish, and superior protection for metal, wood, and masonry surfaces — ensuring superior protection and aesthetic appeal.",
      img: green,
    },
    {
      id: 7,
      name: "Aquatic Wall Sealer",
      description:
        "Specialized undercoat formulation that protects from dampness & alkali attacks, ensuring long-lasting performance in Pakistan’s humid climate conditions.",
      img: cyan,
      // comingSoon: true,
    },
  ];

  return (
    <section className="portfolio-section">
      <h3 className="portfolio-subtitle">
        Premium Paint Products For Every Application
      </h3>
      <p className="portfolio-description">
        Since 1984, Glamur Paints has developed a comprehensive range of paint
        products specifically designed for Pakistan’s diverse architectural
        needs and climate conditions. Our seven specialized paint categories
        ensure we have the perfect solution for every painting project across
        the country.
      </p>

      <h2 className="portfolio-title">Our Complete Product Portfolio</h2>

      <div className="portfolio-grid">
        {/* ROW 1 */}
        <div className="row row-two-cols">
          {products.slice(0, 2).map((item, index) => (
            <div
              className="product-card side-layout"
              key={index}
              onClick={() => openProduct(item.id)}
              role="button"
              tabIndex={0}
              onKeyDown={(event) => handleCardKeyDown(event, item.id)}
            >
              <div className="product-image">
                <img
                  src={item.img}
                  alt={item.name}
                  className={item.comingSoon ? "blurred" : ""}
                />
                {item.comingSoon && <span className="coming">Coming Soon</span>}
              </div>
              <div className="product-info">
                <h4>{item.name}</h4>
                <p>{item.description}</p>
                <div className="arrow">
                  {/* <img src={FaArrowRight} alt="arrow" /> */}
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* ROW 2 */}
        <div className="row row-three-cols">
          {products.slice(2, 5).map((item, index) => (
            <div
              className="product-card top-layout"
              key={index}
              onClick={() => openProduct(item.id)}
              role="button"
              tabIndex={0}
              onKeyDown={(event) => handleCardKeyDown(event, item.id)}
            >
              <div className="product-image">
                <img
                  src={item.img}
                  alt={item.name}
                  className={item.comingSoon ? "blurred" : ""}
                />
                {item.comingSoon && <span className="coming">Coming Soon</span>}
              </div>
              <div className="product-info">
                <h4>{item.name}</h4>
                <p>{item.description}</p>
                <div className="arrow">
                  {/* <img src={FaArrowRight} alt="arrow" /> */}
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* ROW 3 */}
        <div className="row row-two-cols">
          {products.slice(5, 7).map((item, index) => (
            <div
              className="product-card side-layout"
              key={index}
              onClick={() => openProduct(item.id)}
              role="button"
              tabIndex={0}
              onKeyDown={(event) => handleCardKeyDown(event, item.id)}
            >
              <div className="product-image">
                <img
                  src={item.img}
                  alt={item.name}
                  className={item.comingSoon ? "blurred" : ""}
                />
                {item.comingSoon && <span className="coming">Coming Soon</span>}
              </div>
              <div className="product-info">
                <h4>{item.name}</h4>
                <p>{item.description}</p>
                <div className="arrow">
                  {/* <img src={FaArrowRight} alt="arrow" /> */}
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default ProductPortfolio;
